<template>
    <div class="emails mt-2">
        <div v-for="email in emailsToShow" class="email-circle mb-2" :class="[email.status, email.is_customer ? 'customer' : '', isExpanded ? 'isExpanded' : '']" :key="email.id"
            v-tooltip.bottom="{ 
                content: '<div class=\'headline mb-1\'>Email tracker</div><div class=\'fw-600 text-primary\'>' + email.short_subject + '</div><div class=\'badge ' + badgeClass(email) + ' mb-2 mt-1\'>' + badgeText(email) + ' </div><div class=\'fw-600 mb-2\'><span class=\'headline\'>To</span><br /><span class=\'\'>' + email.name + ' (' + email.email + ')</span></div><div class=\'fw-600 mb-2\'><span class=\'headline\'>Sent</span><br /><span class=\'\'>' + fullDate(email.sent_at) + '</span></div><div class=\' \'>' + emailTooltip(email) + '</div>',
                html: true 
            }">
            {{ email.initials }}
        </div><div v-if="showNonRecentEmails" @mouseover="mouseOverMoreEmails" @mouseleave="mouseLeaveMoreEmails" class="email-circle more mb-2" :class="[isExpanded ? 'isExpanded' : '']" v-on:click.stop="clickedShowAllEmails">{{ moreEmailsCopy }}</div>
    </div>
</template>

<script>
    export default {
        props: ['emails', 'isExpanded'],

        created: function() {

        },

        mounted: function() {

        },

        data: function() {
            return {
                showAllEmails: false,
                hoverMoreEmails: false,
            };
        },

        computed: {
            showNonRecentEmails: function() {
                return !this.showAllEmails && this.allNonRecentEmails.length > 0;
            },

            emailsToShow: function() {
                if (this.showAllEmails) {
                    return this.emails;
                }
                return this.recentBatch;
            },

            recentBatch: function() {
                let mostRecent = _.first(this.emails);
                let recentBatch = _.filter(this.emails, email => {
                    return email.batch_id === mostRecent.batch_id;
                });
                return recentBatch;
            },

            allNonRecentEmails: function() {
                let mostRecent = _.first(this.emails);
                let nonRecentBatch = _.filter(this.emails, email => {
                    return email.batch_id !== mostRecent.batch_id;
                });
                return nonRecentBatch;
            },

            moreEmailsCopy: function() {
                if (this.hoverMoreEmails) {
                    return 'Show ' + this.allNonRecentEmails.length + ' more emails';
                }

                return this.allNonRecentEmails.length + ' more';
            }
        },

        methods: {
            mouseOverMoreEmails: function() {
                this.hoverMoreEmails = true;
            },

            mouseLeaveMoreEmails: function() {
                this.hoverMoreEmails = false;
            },

            clickedShowAllEmails: function() {
                this.showAllEmails = true;
            },

            emailTooltip: function(email) {
                if (email.status === 'Delivered') {
                    return 'This email was successfully delivered to ' + email.name + ' ' + this.prettyDate(email.delivered_at) + ' but has not been opened yet.';
                }
                else if (email.status === 'Opened') {
                    if (email.open_count > 1) {
                        return 'This email was first opened by ' + email.name + ' ' + this.prettyDate(email.opened_at) + '. It\'s been opened ' + email.open_count + ' times.';
                    }
                }

                return '';
            },

            badgeText: function(email) {
                if (email.status === 'Opened') {
                    if (email.open_count == 1) {
                        return 'Opened ' + this.prettyDate(email.opened_at);
                    }
                }
                else if (email.status === 'Failed') {
                    return 'Failed to send to ' + email.email + ' ' + this.prettyDate(email.failed_at) + ' for reason: ' + email.failed_description + '.';
                }

                return email.status;
            },

            badgeClass: function(email) {
                if (email.status === 'Opened') {
                    return 'badge-success';
                }

                return 'badge-secondary';
            },

            prettyDate: function(date)
            {
                return moment.utc(date).local().fromNow();
            },

            fullDate: function(date) {
                return moment.utc(date).local().format('MMMM D YYYY h:mm A');
            }
        }
    }
</script>
